import WidgetPage from './WidgetPage';

export default WidgetPage;
